/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import moment from 'moment';
import {PageTitle} from '../../../../../../_metronic/layout/core';
import ModeToolbar from '../../../../../modules/ModeToolbar';
import Header from '../../RD/top/Header';
import Footer from '../../RD/top/Footer';
import List from './List';
import PageWrapper from '../../../../../modules/PageWrapper';
import {findKPIRd} from '../../../../../functions/findKPI';
import ButtonExel from '../../../../../modules/ButtonExel';
import {formatNumber2} from '../../../../../functions/formatNumber';

const TOPLTCWrapper = () => {
  const [data, setData] = useState(null);
  const [roles, setRoles] = useState([]);
  const [time, setTime] = useState({});

  return (
    <PageWrapper
      firstTimeConfig='week_sales_periods'
      breadcrumbs={[
        {title: 'PanelHunt', path: ''},
        {isSeparator: true},
        {title: 'Отдел продаж', path: '/dashboard/sales'},
        {isSeparator: true},
        {title: 'TOP RD менеджера', path: '/sales/rd/top/managers', isActive: true},
      ]}
      buttonKPI={
        roles.includes(4) ||
        roles.includes(8) ||
        roles.includes(30) ||
        roles.includes(13) ||
        roles.includes(32) ? (
          <ButtonExel
            data={data}
            fieldsToKeep={[
              'place',
              'id',
              'first_name',
              'last_name',
              'sales_team_id',
              'teamleader_id',
              'teamleader_first_name',
              'teamleader_last_name',
              'activity',
              'forecast_activity',
              'amounts_deposits',
              'payout',
              'count_leads',
              'count_qualifications',
              'count_leads',
              'rd',
              'is_ban',
              'ban_date',
              'is_verified',
              'verify_date',
              'created_at',
              'wallet_created_at',
              'wallet_currency',
              'wallet_details',
              'wallet_id',
              'wallet_type',
            ]}
            columnFormats={{forecast_pay: '$#,##0.00', forecast_amounts_deposits: '$#,##0.00'}}
            fileName={'rating_rd_managers'}
            time={time}
          />
        ) : (
          <></>
        )
      }
      title={'TOP RD Менеджеров'}
    >
      <TOPRD setObjForExel={setData} setRoles={setRoles} setTimeForExel={setTime} />
    </PageWrapper>
  );
};

const TOPRD = observer(
  ({isVerify, timeConfig, setPreloader, setObjForExel, setTimeForExel, setRoles}) => {
    const store = useStore();
    const [data, setData] = useState([]);
    const [footerData, setFooterData] = useState([]);

    useEffect(() => {
      setObjForExel(null);
      setRoles(store.roles);
      isVerify && getData();
    }, [isVerify, timeConfig]);

    const getData = async () => {
      const [result, getTeams, RDList] = await Promise.all([
        store.requestGet('Sales/Rd/Managers/getTop', {
          params:
            timeConfig.time_config === 'week_sales_periods'
              ? {time_config: '', time_start: '', time_end: ''}
              : timeConfig,
          returnFullObj: true,
        }),
        store.requestGet(`Sales/getRdManagersList`, {
          params: {type: 'rd'},
        }),
        store.requestGet(`Sales/getKpiRdList`),
      ]);

      const newList = result.data
        .map((item) => {
          const findTeam = getTeams.find((el) => el.id === item.sales_team_id);

          return {
            ...item,
            team: findTeam,
            full_name: `${item.first_name} ${item.last_name}`,
            status: findKPIRd(
              RDList,
              item?.count_qualifications,
              item?.activity,
              item?.rd,
              'manager_kpi'
            ),
            place: item?.place === 0 ? 99999 : item?.place,
          };
        })
        .sort((a, b) => a?.place - b?.place);

      const dataForExel = newList.map((item) => {
        return {
          ...item,
          teamleader_id: item?.team?.teamleader?.id,
          teamleader_first_name: item?.team?.teamleader?.first_name,
          teamleader_last_name: item?.team?.teamleader?.last_name,
          payout: Number(item?.forecast_pay),
          amounts_deposits: Number(item.forecast_amounts_deposits),
          ban_date: !!item?.ban_date ? item?.ban_date : '',
          verify_date: !!item?.verify_date ? item?.verify_date : '',
          is_verified: `${item.is_verified}`,
          is_ban: `${item.is_ban}`,
          created_at: moment.tz(item?.created_at * 1000, 'Europe/Kyiv').format('DD.MM.YYYY HH:mm '),
          activity: `${formatNumber2(item?.activity)}%`,
          forecast_activity: `${formatNumber2(item?.forecast_activity)}%`,
        };
      });
      setTimeForExel(result.time);
      setObjForExel(dataForExel);

      setData(newList);

      const newFooterData = newList.filter((item) => item.place !== 99999);
      setFooterData(newFooterData);
      setPreloader(false);
    };

    return (
      <>
        <Header top_1={data[0]} top_2={data[1]} top_3={data[2]} />
        <List data={data} withoutOutsiders={footerData} />
        <Footer
          data={footerData.slice(footerData.length - 3, footerData.length)}
          length={footerData.length - 2}
        />
      </>
    );
  }
);

export default TOPLTCWrapper;
